import { __awaiter, __decorate, __extends, __generator, __metadata, __values } from "tslib";
import { Component, Vue, Watch } from "vue-ext";
import { WeeeCustomerOrderService, WeeeCustomerProductService } from "@/models";
import { service } from "@/services";
import camelCase from 'camelcase';
import { OrderItemModel } from "./orderItemModel";
var weeeCustomerOrderService = service(WeeeCustomerOrderService);
var weeeCustomerProductService = service(WeeeCustomerProductService);
var OrderCreateRetrievalView = /** @class */ (function (_super) {
    __extends(OrderCreateRetrievalView, _super);
    function OrderCreateRetrievalView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.order = {
            contact: {},
            billingAddress: {},
            deliveryAddress: {}
        };
        _this.weeeProducts = null;
        _this.weeeProductsAndQuantity = [];
        _this.serviceProducts = null;
        _this.isExpressDelivery = false;
        _this.isDifficultLocation = false;
        _this.isDifferentBillingAddress = false;
        _this.hasAccepted = false;
        _this.marketingPermission = false;
        _this.retrieveTrolleyAmount = 0;
        _this.retrieveBinAmount = 0;
        _this.errorMessage = "";
        _this.difficultLocationProductId = "05acc703-39e6-4e06-802c-2302c33a64bd";
        _this.expressDeliveryProductId = "4e201a3f-8fdf-474a-af0d-de4ffc201e42";
        return _this;
    }
    Object.defineProperty(OrderCreateRetrievalView.prototype, "canSave", {
        get: function () {
            if (!this.order.contact.company ||
                !this.order.contact.businessId ||
                !this.order.contact.firstName ||
                !this.order.contact.lastName ||
                !this.order.contact.phone ||
                !this.order.contact.email ||
                this.email(this.order.contact.email) != true ||
                !this.order.deliveryAddress.streetAddress ||
                !this.order.deliveryAddress.zipCode ||
                !this.order.deliveryAddress.city ||
                !this.hasAccepted) {
                return false;
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderCreateRetrievalView.prototype, "unitCount", {
        get: function () {
            return this.weeeProductsAndQuantity
                .filter(function (p) { return p.quantity > 0 && !p.product.isService && !p.product.isAreaFee; })
                .reduce(function (a, b) { return a + b.quantity; }, 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderCreateRetrievalView.prototype, "expressDeliveryPrice", {
        get: function () {
            var _this = this;
            return this.weeeProductsAndQuantity
                .find(function (p) { return p.product.weeeProductId == _this.expressDeliveryProductId; }).product.price;
        },
        enumerable: false,
        configurable: true
    });
    OrderCreateRetrievalView.prototype.routed = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var dataLayer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getProducts()];
                    case 1:
                        _a.sent();
                        if (!this.$route.query.fill) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.autoFillForm(this.$route.query.fill)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        dataLayer = window.dataLayer;
                        if (dataLayer) {
                            dataLayer.push({ "event": "weee_retrieve_order_start", "eventCategory": "Weee" });
                        }
                        this.loading = false;
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    OrderCreateRetrievalView.prototype.getProducts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var searchParams, _a, _b, _c, _d, product, _e, _f, product;
            var e_1, _g, e_2, _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        this.isExpressDelivery = false;
                        this.isDifficultLocation = false;
                        searchParams = {
                            name: "",
                            isService: false,
                            isRetrievalPlaceHolder: true,
                        };
                        this.weeeProducts = null;
                        _a = this;
                        return [4 /*yield*/, weeeCustomerProductService.searchWeeeCustomerProducts(searchParams)];
                    case 1:
                        _a.weeeProducts = _j.sent();
                        _b = this;
                        return [4 /*yield*/, weeeCustomerProductService.searchWeeeCustomerProducts({ name: "", isService: true, isRetrievalPlaceHolder: false })];
                    case 2:
                        _b.serviceProducts = _j.sent();
                        try {
                            for (_c = __values(this.weeeProducts.items), _d = _c.next(); !_d.done; _d = _c.next()) {
                                product = _d.value;
                                this.weeeProductsAndQuantity.push(new OrderItemModel(product, 0));
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_g = _c.return)) _g.call(_c);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        try {
                            for (_e = __values(this.serviceProducts.items), _f = _e.next(); !_f.done; _f = _e.next()) {
                                product = _f.value;
                                this.weeeProductsAndQuantity.push(new OrderItemModel(product, 0));
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_f && !_f.done && (_h = _e.return)) _h.call(_e);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    OrderCreateRetrievalView.prototype.autoFillForm = function (source) {
        return __awaiter(this, void 0, void 0, function () {
            var response, weeeOrderCreateRequest, weeeOrderItems, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!(source == "lastOrder")) return [3 /*break*/, 2];
                        return [4 /*yield*/, weeeCustomerOrderService.getLastOrderDetails()];
                    case 1:
                        response = _a.sent();
                        if (!response) {
                            return [2 /*return*/];
                        }
                        this.order.contact.company = response.contact.company;
                        this.order.contact.businessId = response.contact.businessId;
                        this.order.contact.firstName = response.contact.firstName;
                        this.order.contact.lastName = response.contact.lastName;
                        this.order.contact.phone = response.contact.phone;
                        this.order.contact.email = response.contact.email;
                        this.order.deliveryAddress.company = response.deliveryAddress.company;
                        this.order.deliveryAddress.streetAddress = response.deliveryAddress.streetAddress;
                        this.order.deliveryAddress.zipCode = response.deliveryAddress.zipCode;
                        this.order.deliveryAddress.city = response.deliveryAddress.city;
                        if (response.hasSingleAddress !== true) {
                            this.isDifferentBillingAddress = true;
                            this.order.billingAddress.streetAddress = response.billingAddress.streetAddress;
                            this.order.billingAddress.zipCode = response.billingAddress.zipCode;
                            this.order.billingAddress.city = response.billingAddress.city;
                        }
                        this.order.customerOrderNumber = response.customerOrderNumber;
                        this.order.ovtNumber = response.ovtNumber;
                        this.order.ovtOperator = response.ovtOperator;
                        this.order.extraInformation = response.extraInformation;
                        return [3 /*break*/, 3];
                    case 2:
                        if (source == "store") {
                            weeeOrderCreateRequest = this.$customerOrderStore.getWeeeOrderCreateRequest();
                            weeeOrderItems = this.$customerOrderStore.getWeeeOrderItems();
                            this.$customerOrderStore.removeWeeeOrderCreateRequest();
                            this.$customerOrderStore.removeWeeeOrderItems();
                            this.order.contact = weeeOrderCreateRequest.contact;
                            this.order.deliveryAddress = weeeOrderCreateRequest.deliveryAddress;
                            if (weeeOrderCreateRequest.hasSingleAddress !== true) {
                                this.isDifferentBillingAddress = true;
                                this.order.billingAddress = weeeOrderCreateRequest.billingAddress;
                            }
                            this.order.customerOrderNumber = weeeOrderCreateRequest.customerOrderNumber;
                            this.order.ovtNumber = weeeOrderCreateRequest.ovtNumber;
                            this.order.ovtOperator = weeeOrderCreateRequest.ovtOperator;
                            this.order.extraInformation = weeeOrderCreateRequest.extraInformation;
                            weeeOrderItems.filter(function (i) { return !i.product.isService && !i.product.isAreaFee; }).forEach(function (i) {
                                _this.weeeProductsAndQuantity.find(function (p) { return p.product.isRetrievalPlaceHolder && p.product.productType === i.product.productType; }).quantity += i.quantity;
                            });
                            if (weeeOrderItems.find(function (p) { return p.product.weeeProductId == _this.difficultLocationProductId; })) {
                                this.isDifficultLocation = true;
                            }
                            if (weeeOrderItems.find(function (p) { return p.product.weeeProductId == _this.expressDeliveryProductId; })) {
                                this.isExpressDelivery = true;
                            }
                        }
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        return [2 /*return*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    OrderCreateRetrievalView.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        if (this.weeeProductsAndQuantity.filter(function (p) { return p.quantity > 0 && !p.product.isService && !p.product.isAreaFee; }).length == 0) {
                            this.errorMessage = this.$t("weeeCustomerOrder.noUnitsSelectedError").toString();
                            window.scrollTo(0, 0);
                            this.loading = false;
                            return [2 /*return*/];
                        }
                        if (this.order.deliveryAddress.zipCode.startsWith("22")) {
                            this.errorMessage = this.$t("weeeCustomerOrder.aalandZipCodeError").toString();
                            window.scrollTo(0, 0);
                            this.loading = false;
                            return [2 /*return*/];
                        }
                        request = {
                            billingAddress: this.order.billingAddress,
                            customerOrderNumber: this.order.customerOrderNumber,
                            ovtNumber: this.order.ovtNumber,
                            ovtOperator: this.order.ovtOperator,
                            deliveryAddress: this.order.deliveryAddress,
                            contact: this.order.contact,
                            hasSingleAddress: !this.isDifferentBillingAddress,
                            direction: "Retrieve",
                            items: this.setWeeeOrderItems(),
                            latitude: null,
                            longitude: null,
                            extraInformation: this.order.extraInformation,
                            marketingPermission: this.marketingPermission,
                        };
                        if (!this.hasAccepted) return [3 /*break*/, 2];
                        return [4 /*yield*/, weeeCustomerOrderService.createWeeeCustomerOrder(request)];
                    case 1:
                        response = _a.sent();
                        if (response.status == "Success") {
                            this.$customerOrderStore.setWeeeOrderCreateRequest(request);
                            this.$customerOrderStore.setWeeeOrderItems(this.weeeProductsAndQuantity);
                            this.$router.push("/kiitos");
                        }
                        else {
                            this.errorMessage = this.$t("weeeCustomerOrder.unhandledError").toString();
                        }
                        _a.label = 2;
                    case 2:
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    OrderCreateRetrievalView.prototype.setWeeeOrderItems = function () {
        var weeeOrderItemCreateRequests = [];
        this.weeeProductsAndQuantity.forEach(function (value) {
            for (var i = 0; i < value.quantity; i++) {
                weeeOrderItemCreateRequests.push({
                    weeeProductId: value.product.weeeProductId,
                    extraServices: value.extraServices
                });
            }
        });
        return weeeOrderItemCreateRequests;
    };
    OrderCreateRetrievalView.prototype.getProductLabel = function (productName) {
        var key = "weeeCustomerOrder.productLabel." + camelCase(productName);
        return this.$te(key)
            ? this.$t(key)
            : productName;
    };
    OrderCreateRetrievalView.prototype.required = function (value) {
        return !!value || false;
    };
    OrderCreateRetrievalView.prototype.email = function (value) {
        if (value === null || value === void 0 ? void 0 : value.length) {
            var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regex.test(value) || this.$t("validationErrors.invalidEmail").toString();
        }
        return true;
    };
    OrderCreateRetrievalView.prototype.isDifficultLocationChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            var i;
            return __generator(this, function (_a) {
                for (i = 0; i < this.weeeProductsAndQuantity.length; i++) {
                    if (this.weeeProductsAndQuantity[i].product.weeeProductId === this.difficultLocationProductId) {
                        if (this.isDifficultLocation) {
                            this.weeeProductsAndQuantity[i].quantity = 1;
                        }
                        else {
                            this.weeeProductsAndQuantity[i].quantity = 0;
                        }
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    OrderCreateRetrievalView.prototype.isExpressDeliveryChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            var i;
            return __generator(this, function (_a) {
                for (i = 0; i < this.weeeProductsAndQuantity.length; i++) {
                    if (this.weeeProductsAndQuantity[i].product.weeeProductId === this.expressDeliveryProductId) {
                        if (this.isExpressDelivery) {
                            this.weeeProductsAndQuantity[i].quantity = this.unitCount == 0 ? 1 : this.unitCount;
                        }
                        else {
                            this.weeeProductsAndQuantity[i].quantity = 0;
                        }
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    OrderCreateRetrievalView.prototype.isUnitCountChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            var expressDelivery;
            var _this = this;
            return __generator(this, function (_a) {
                expressDelivery = this.weeeProductsAndQuantity.find(function (p) { return p.product.weeeProductId == _this.expressDeliveryProductId; });
                if (expressDelivery.quantity > 0) {
                    expressDelivery.quantity = this.unitCount;
                }
                return [2 /*return*/];
            });
        });
    };
    __decorate([
        Watch("isDifficultLocation"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], OrderCreateRetrievalView.prototype, "isDifficultLocationChanged", null);
    __decorate([
        Watch("isExpressDelivery"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], OrderCreateRetrievalView.prototype, "isExpressDeliveryChanged", null);
    __decorate([
        Watch("unitCount"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], OrderCreateRetrievalView.prototype, "isUnitCountChanged", null);
    OrderCreateRetrievalView = __decorate([
        Component
    ], OrderCreateRetrievalView);
    return OrderCreateRetrievalView;
}(Vue));
export default OrderCreateRetrievalView;
